import ChatBubble from "../ChatBubble";
import { ChatBubbleProps } from "../ChatBubble/ChatBubble";
import Chatbox from "../Chatbox";
import React from "react";

export interface LiveChatTabProps {
  comments: ChatBubbleProps[];
  onNewMessage: (comment: string) => void;
}

const LiveChatTab = ({ comments, onNewMessage }: LiveChatTabProps) => {
  const handleNewMessage = (comment: string) => {
    onNewMessage(comment);
  };

  return (
    <div className="relative w-full h-full">
      <div
        className="w-full h-full"
        style={{
          minHeight: "300px",
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full overflow-y-scroll">
          <div className="pb-8 my-4 space-y-4">
            {comments.length ? (
              comments.map((comment, key) => (
                <div className="w-full" key={key}>
                  <ChatBubble {...comment} />
                </div>
              ))
            ) : (
              <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-200 rounded">
                No comments.
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 flex items-center w-full bg-gray-100">
        <Chatbox onNewMessage={handleNewMessage} />
      </div>
    </div>
  );
};

export default LiveChatTab;
